import { useSetRecoilState } from 'recoil';
import { companyState } from '../states'; // Ensure navigationState is correctly imported
import { CompanyDto } from '@jaam/commons/dtos';
import { useSettingsPanel } from '../context/SettingsPanelContext';
import { AUTH_API } from '../services/axios';

export const useSelectCompany = () => {
  const setCurrentCompanyState = useSetRecoilState(companyState);
  const { setCloseSettingsPanel } = useSettingsPanel();
  const updateActiveCompany = async (companyId: number) => {
    const response = await AUTH_API.post('/auth/update-active-company', {
      companyId: companyId,
    });
    return response.data;
  };
  const handleClick = async (company: CompanyDto) => {
    try {
      if (company.id) {
        await updateActiveCompany(company.id);
        setCloseSettingsPanel(false);
        window.location.reload();
      } else {
        setCurrentCompanyState((prev) => ({
          ...prev,
          activeCompany: company,
        }));
        setCloseSettingsPanel(false);
      }
    } catch (error) {
      console.error('Error updating active company:', error);
    }
  };

  return [handleClick];
};
